import React from "react"
import { flatMap, filter, uniq } from "lodash"
import { Popover } from "antd"

export const columns = (setStateFrom, employees, secondStepData) => {
  const anonymity = Number(secondStepData.anonymity) || 3
  const messageDisable = (
    <p style={{ marginBottom: 0 }}>
      No es posible seleccionar equipos que <br />
      tengan menos de{" "}
      <strong>
        {anonymity} {anonymity === 1 ? "colaborador" : "colaboradores"}
      </strong>
      .
    </p>
  )

  return [
    {
      title: "Líder",
      dataIndex: "full_name",
      key: "full_name",
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      width: 320,
      render: (text, record) => {
        if (record.team.length >= anonymity)
          return `${record.first_name} ${record.last_name}`

        return (
          <Popover placement="topLeft" content={messageDisable}>
            <div
              className={
                record.team.length < anonymity
                  ? "select-leadership-row-disabled"
                  : ""
              }>
              {`${record.first_name} ${record.last_name}`}
            </div>
          </Popover>
        )
      },
    },
    {
      title: "División",
      dataIndex: "name_division",
      key: "name_division",
      render: (text, record) => {
        if (record.team.length >= anonymity) return text

        return (
          <Popover placement="topLeft" content={messageDisable}>
            <div
              className={
                record.team.length < anonymity
                  ? "select-leadership-row-disabled"
                  : ""
              }>
              {text}
            </div>
          </Popover>
        )
      },
    },
    {
      title: "Destinatarios",
      dataIndex: "collaborators_quantity",
      key: "collaborators_quantity",
      render: (text, record) => {
        const onlyIdsRecord = flatMap(record.team, (item) => item.employee_id)
        const filterEmployees = filter(uniq(employees), (item) =>
          onlyIdsRecord.includes(item)
        )

        if (record.team.length >= anonymity)
          return `${filterEmployees.length}/${text}`

        return (
          <Popover placement="topLeft" content={messageDisable}>
            <div
              className={
                record.team.length < anonymity
                  ? "select-leadership-row-disabled"
                  : ""
              }>
              {filterEmployees.length}/{text}
            </div>
          </Popover>
        )
      },
    },
    {
      title: "Puesto",
      dataIndex: "name_position",
      key: "name_position",
      render: (text, record) => {
        if (record.team.length >= anonymity) return text

        return (
          <Popover placement="topLeft" content={messageDisable}>
            <div
              className={
                record.team.length < anonymity
                  ? "select-leadership-row-disabled"
                  : ""
              }>
              {text}
            </div>
          </Popover>
        )
      },
    },
    {
      title: "Acciones",
      render: (_, record) => {
        if (record.team.length < anonymity) return ""

        return (
          <span
            onClick={() => setStateFrom("modalSelectLeadership", true, record)}
            style={{
              textDecoration: "underline",
              color: "#378FEE",
              cursor: "pointer",
            }}>
            Editar destinatarios
          </span>
        )
      },
    },
  ]
}
